import React, { useState, useEffect, useContext } from 'react'
import { OrderCalendar } from '../Icons/OrderDrawer'
import MyHeaderBg from '../myComponents/MyHeaderBg/MyHeaderBg'
import YyFood from '../Icons/YyFood'
import Add from '../Icons/Add'
import Decrease from '../Icons/Decrease'
import { OrderInfoContext } from '../../contexts/OrderInfo'
import { OrderMarkContext } from '../../contexts/OrderMark'
import { OrderPriceContext } from '../../contexts/OrderPrice'
import { Session } from '../../contexts/Session'
import { LanguageContext } from '../../contexts/LanguageContext'
import MyModal from '../myComponents/MyModal/MyModal'
import OrderDefinedPay from './OrderDefinedPay'
import OrderDefinedPotPay from './OrderDefinedPotPay'
import intl from 'react-intl-universal'
import ShoppingCar from '../Icons/ShoppingCar'
import MyNavBar2 from '../myComponents/MyHeader/MyNavBar2'
import {
  OrderDefinedHeaderWrapper,
  OrderComfirmBox,
  OrderShoppingBar,
  OrderShoppingMask
} from './OrderStyle.js'
import {
  foodDecrease,
  foodIncrease,
  readFromCacheIface,
  updateDate,
  updatePrice,
  updatePayPrice,
  getPatientInfo,
  checkIsContainPotFood,
  updateYyXgPrice,
  addFoodTestForMax,
  isObjEmpty
} from './OrderFunction'

export default function OrderDefined (props) {
  // console.log(props)
  const OrderInfo = useContext(OrderInfoContext)
  const OrderMark = useContext(OrderMarkContext)
  const OrderPrice = useContext(OrderPriceContext)
  const SessionContext = useContext(Session)
  const Language = useContext(LanguageContext)
  const [showModal, setShowModal] = useState(false) // 是否显示提示信息弹窗
  const [modalInfo, setModalInfo] = useState('') // 提示信息弹窗的提示文本内容
  const [dateArr, setDateArr] = useState([])
  const [isshow, setIsshow] = useState(false)
  const [advanceDay, setAdvanceDay] = useState(0) // 提前多少天预订的
  // 进入此页面的时候，如果发现前端缓存没有数据，就请求一次后端接口写入缓存。防止是用户操作刷新导致的前端缓存数据丢失
  useEffect(() => {
    if (OrderInfo.cacheAllFoodList.length <= 0) {
      // console.log('读取缓存')
      readFromCacheIface(OrderInfo, Language, setShowModal, setModalInfo)
    } else {
      const tmp = OrderInfo.cacheAllFoodList.filter(item => item.selectedQuantity > 0)
      OrderInfo.setCacheAllFoodList(tmp)
    }
  }, [])
  // 设置需要提前多少天预订饭菜
  useEffect(() => {
    if (!isObjEmpty(OrderMark.properties)) {
      if (OrderMark.properties.effectiveDays) {
        OrderMark.properties.effectiveDays.length > 0 && setAdvanceDay(OrderMark.properties.effectiveDays[0])
      }
    }
  }, [OrderMark.properties])
  // 如果App.js获取失败了，重新获取 床位号 和 病人姓名
  useEffect(() => { // 已做过测试
    if (OrderMark.position === '' || OrderMark.foodAdvice === '') {
      getPatientInfo(OrderMark, SessionContext)
    }
  }, [SessionContext])

  // 如果缓存的营养餐或者小锅菜改动了，则更新一下日期列表,更新一下价格
  useEffect(() => {
    updateDate(OrderInfo, setDateArr)
    updatePrice(OrderInfo, OrderPrice)
    updatePayPrice(OrderInfo, OrderMark, OrderPrice)
    checkIsContainPotFood(OrderInfo, OrderMark, OrderPrice)
    updateYyXgPrice(OrderInfo, OrderPrice)
    // console.log(dateArr)
  }, [OrderInfo])
  // 如果缓存的包伙制信息改变了，则更新一下日期列表,更新一下价格
  useEffect(() => {
    updatePrice(OrderInfo, OrderPrice)
    updatePayPrice(OrderInfo, OrderMark, OrderPrice)
    checkIsContainPotFood(OrderInfo, OrderMark, OrderPrice)
    updateYyXgPrice(OrderInfo, OrderPrice)
  }, [OrderMark.properties])
  return (
    <div className='h100 rel ovh ffyy'>
      <div className='h100 ova rel'>
        <OrderDefinedHeaderWrapper className='rel'>
          <MyHeaderBg />
          <MyNavBar2 history={props.history}>{intl.get('Comfirmation of orders')}</MyNavBar2>
        </OrderDefinedHeaderWrapper>
        <OrderComfirmBox className='h86 fs14 mt-30'>
          <div className='pl12 pr12 h90'>
            {
              dateArr.length > 0 && dateArr.map((dateItem, dataIndex) => {
                // console.log(dateItem)
                return (
                  <div key={dataIndex} className='outside-box'>
                    {
                      OrderMark.mealtypes.map((mealItem, mealIndex) => {
                        // console.log(mealItem)
                        return (
                          <div key={mealIndex}
                            className={'comfirm-item bgf rel pb10 ' + (
                              OrderInfo.cacheAllFoodList.filter(item => item.dayTime && dateItem && item.dayTime.substr(0, 10) === dateItem.substr(0, 10) && mealItem.id === item.mealTypeID).length > 0 ? ' db ' : ' dn ')}
                            style={{ zIndex: -mealIndex + OrderMark.mealtypes.length, margin: '0 0 -32px' }}
                          >
                            <ul className='h30px bgf7 pl6 flex rds5'>
                              <li className='w15 pl10'><OrderCalendar /></li>
                              <li className='w85 fs14'>{dateItem}</li>
                            </ul>
                            <div className='pl12'>
                              <div key={mealIndex}>
                                <div className='meal-type dib rds5 mt10 pl5 pr5 tc gf h20r' style={{ lineHeight: '1.4285rem' }}>{mealItem.mealName}</div>
                                {
                                  OrderInfo.cacheAllFoodList.map((itemData, foodIndex) => {
                                    // console.log(itemData)
                                    if (itemData.dayTime && dateItem === itemData.dayTime.substr(0, 10) && mealItem.id === itemData.mealTypeID) {
                                      return (
                                        <ul key={foodIndex} className='flex g4f'
                                          style={{ color: itemData.allowOrder.includes('error_limitOne') ? (itemData.selectedQuantity > 1 ? '#f31c69' : '')
                                            : (itemData.allowOrder.includes('error') && itemData.selectedQuantity > 0 ? '#f31c69' : '') }}>
                                          <li className={'w65 fs13 pl8 rel' + (Language.locale === 'en' ? '' : ' lt1-5')} style={{paddingTop:'2%',lineHeight:'20px'}}>
                                            {
                                              !itemData.isPotFood && <div className='dib abs' style={{paddingTop:'3%'}}><YyFood height={15} width={15} /></div>
                                            }
                                            {
                                              !itemData.isPotFood ? <div className='pl20' style={{overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp:2,WebkitBoxOrient:'vertical',display:'-webkit-box',paddingTop:'2%',lineHeight:'20px'}}>
                                                {itemData.foodName}
                                                {itemData.allowOrder.includes('error_notInAllowDate') && itemData.selectedQuantity > 0 ? '(' + intl.get('Invalid') + ')' : ''}
                                                {itemData.allowOrder.includes('error_outToDate') && itemData.selectedQuantity > 0 ? '(' + intl.get('overdue') + ')' : ''}
                                                {itemData.allowOrder.includes('error_soldOut') && itemData.selectedQuantity > 0 ? '(' + intl.get('Sold out') + ')' : ''}
                                                {itemData.allowOrder.includes('error_Invalid') && itemData.selectedQuantity > 0 ? '(' + intl.get('Invalid') + ')' : ''}
                                                {itemData.allowOrder.includes('error_alreadyOrder') && itemData.selectedQuantity > 0 ? '(' + intl.get('Duplicate') + ')' : ''}
                                                {itemData.allowOrder.includes('error_limitOne') && itemData.selectedQuantity > 1 ? '(' + intl.get('Limit one') + ')' : ''}
                                                {itemData.allowOrder.includes('error_patientNoOrder') && itemData.selectedQuantity > 0 ? '(' + intl.get('Invalid') + ')' : ''}
                                                {itemData.allowOrder.includes('error_prepareBySelf') && itemData.selectedQuantity > 0 ? '(' + intl.get('Invalid') + ')' : ''}
                                              </div> : <div>
                                                {itemData.foodName}
                                                {itemData.allowOrder.includes('error_notInAllowDate') && itemData.selectedQuantity > 0 ? '(' + intl.get('Invalid') + ')' : ''}
                                                {itemData.allowOrder.includes('error_outToDate') && itemData.selectedQuantity > 0 ? '(' + intl.get('overdue') + ')' : ''}
                                                {itemData.allowOrder.includes('error_soldOut') && itemData.selectedQuantity > 0 ? '(' + intl.get('Sold out') + ')' : ''}
                                                {itemData.allowOrder.includes('error_Invalid') && itemData.selectedQuantity > 0 ? '(' + intl.get('Invalid') + ')' : ''}
                                              </div>
                                            }
                                          </li>
                                          <li className='w15 fw5'>
                                            {
                                              <span>&yen;{itemData.unitPrice===0?' --':' '+ itemData.unitPrice}</span>
                                            }
                                          </li>
                                          <li className='w20 rel b3 h100'>
                                            <div
                                              className={'abs b0 h1' + (itemData.selectedQuantity <= 0 ? ' disabled' : '')}
                                              style={{ right: '3.1rem' }}
                                              onClick={() => { foodDecrease(itemData, OrderInfo) }}
                                            >
                                              {
                                                itemData.selectedQuantity === 0 ? <Decrease /> : <Decrease circleBg={'#f31c69'} />
                                              }
                                            </div>
                                            <div className='abs w23r tc r20 b2 h1'>{itemData.selectedQuantity}</div>
                                            <div
                                              className='abs r5 b0 h1'
                                              onClick={() => {
                                                foodIncrease(itemData, OrderInfo, setShowModal, setModalInfo, dateItem, OrderMark)
                                              }}
                                            >
                                              {
                                                addFoodTestForMax(itemData, OrderInfo, dateItem) ? <Add /> : <Add circleBg={'#f31c69'} />
                                              }
                                            </div>
                                          </li>
                                        </ul>
                                      )
                                    }
                                  })
                                }
                              </div>
                            </div>
                          </div>
                        )
                      })
                    }
                  </div>
                )
              })
            }
          </div>
          {/* <div style={{ height: '260px' }} /> */}
          {
            // OrderPrice.isYyPot || OrderPrice.isXgPot ? <div style={isshow ? { height: '290px' } : {}} /> : <div style={isshow ? { height: '235px' } : {}} />
          }
        </OrderComfirmBox>
      </div>
      <div className='h7 w100 abs b0 l0 zx100'>
        <OrderShoppingBar className='flex h100 w100 abs zx100'>
          <li className='w75 h100 flex bg59' style={{ opacity: '0.65' }} onClick={() => setIsshow(!isshow)}>
            <div className='w20 h100 flex left-arrow-icon '>
              <div className='auto p4'><ShoppingCar /></div>
            </div>
            <div className='w80 h100 gf fw3 rel middle-text fs14'>
              <div className='mauto h18e lt2'>{intl.get('Total:')}&yen;{OrderPrice.price.toFixed(2)}</div>
            </div>
          </li>
          <li
            className='w25 h100 rel right-text'
          >
            <button id='writtenBtnid' className='abs clip'
              onClick={() => { setIsshow(!isshow) }}
            />
            <label htmlFor='writtenBtnid' className='db h100 w100'>
              <div className='mauto tc gf h15r lt2'>{intl.get('Settlement')}</div>
            </label>
          </li>
        </OrderShoppingBar>
      </div>
      <OrderShoppingMask
        className={'abs trbl0 bg0 zx80' + (isshow ? ' ' : ' dn')}
        onClick={() => { setIsshow(!isshow) }}
      />
      {
        OrderPrice.isYyPot || OrderPrice.isXgPot ? <OrderDefinedPotPay isshow={isshow} setIsshow={setIsshow} setShowModal={setShowModal} setModalInfo={setModalInfo} history={props.history} advanceDay={advanceDay} />
          : <OrderDefinedPay isshow={isshow} setIsshow={setIsshow} setShowModal={setShowModal} setModalInfo={setModalInfo} history={props.history} advanceDay={advanceDay} />
      }
      <MyModal
        visible={showModal}
        info={modalInfo}
        cancelButtonVisible={false}
        onOkClick={() => setShowModal(false)}
      />
    </div>
  )
}
